export default "__VITE_ASSET__jYpeaGlL__"